import React from "react";
import styled from "styled-components";

const Wrap = styled.div``;

const Content = () => {
  return (
    <>
      <Wrap>
        <h2>What We Do</h2>
        <p>
        Madrone Mental Health Services is small mental health agency established in September 2015. We serve individuals, families, parents, and couples with behavioral and mental health needs. We dedicate ourselves to providing effective, professional, and meaningful services guided by evidenced based practices in the fields of behavioral and mental health.
        </p>
        <p>
        Therapists are trained in and employ evidence-based practices to support individual, familial or couples growth.  Therapy includes a mixture of Cognitive Behavior Therapy, Dialectical Behavior Therapy, Family Systems Theory, Motivational Interviewing, and Mindfulness Practices. Our services are designed to be targeted, effective, and collaborative.
        </p>
        <p>
        Clients will work with the therapist to identify a specific goal to focus on during therapy and develop a treatment plan to achieve that goal. Our therapists are trained to engage clients from the first session in an action-based therapy. Clients can expect to practice skills that will allow them to manage their thoughts, behaviors, and emotions when they are no longer in therapy.
        </p>

        <a
          href="https://g.co/kgs/5WuHKtn"
          target="_blank"
          rel="noopener noreferrer"
        >
          Visit our Office
        </a> 
      </Wrap>
    </>
  );
};

export default Content;
